import { BaseComponent } from '../../lib/base-component.js';
import { css, html } from '../../vendor/lit.min.js';

class TermsOfService extends BaseComponent {
    static styles = css`
        :host { display: block; }
        h2 { font-size: 1.25rem; margin-top: 1.5rem; }
        h3 { font-size: 1.1rem; margin-top: 1rem; }
        ul { padding-left: 1.5rem; }
    `;

    render() {
        return html`
            <p><strong>Last Updated: March 2026</strong></p>
            <p><strong>IMPORTANT: PLEASE READ THESE TERMS CAREFULLY BEFORE USING THIS SERVICE.</strong></p>
            <p>These Terms of Service ("Terms") constitute a legally binding agreement between you ("User," "you," or "your") and Dice Driven Design LLC ("Company," "we," "us," or "our") governing your access to and use of the Dice Driven Design authentication service, including any associated websites, applications, and services (collectively, the "Service").</p>
            <p>By creating an account or using the Service, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use the Service.</p>

            <h2>1. Eligibility</h2>
            <h3>1.1 Age Requirement</h3>
            <p>The Service is intended for users who are 13 years of age or older. By creating an account or using the Service, you represent and warrant that you are at least 13 years old.</p>
            <p>If you are under 13 years of age, you may not create an account or use the Service. We do not knowingly collect personal information from children under 13.</p>
            <p>If you are between 13 and 18 years of age (or the age of legal majority in your jurisdiction), you may only use the Service with the consent of a parent or legal guardian who agrees to be bound by these Terms.</p>

            <h3>1.2 Account Registration</h3>
            <p>To access the Service, you must have an account created by an administrator. You agree to:</p>
            <ul>
                <li>Maintain and promptly update your account information</li>
                <li>Maintain the security of your password and accept responsibility for all activities under your account</li>
                <li>Immediately notify us of any unauthorized use of your account</li>
            </ul>

            <h2>2. Description of Service</h2>
            <p>The Service provides authentication and identity management for Dice Driven Design applications. This includes user login, password management, single sign-on, and related functionality.</p>

            <h2>3. User Conduct</h2>
            <p>You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:</p>
            <ul>
                <li>Use the Service in any way that violates applicable laws or regulations</li>
                <li>Impersonate any person or entity or misrepresent your affiliation</li>
                <li>Attempt to gain unauthorized access to any portion of the Service or any systems or networks connected to the Service</li>
                <li>Interfere with or disrupt the Service or servers or networks connected to the Service</li>
                <li>Share your account credentials with others</li>
            </ul>

            <h2>4. Intellectual Property</h2>
            <p>The Service, including its original content, features, and functionality, is owned by Dice Driven Design LLC and is protected by copyright, trademark, and other intellectual property laws.</p>

            <h2>5. Privacy</h2>
            <p>Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference.</p>

            <h2>6. Disclaimers</h2>
            <h3>6.1 "As Is" Basis</h3>
            <p>THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.</p>

            <h3>6.2 No Guarantee</h3>
            <p>We do not warrant that the Service will be uninterrupted, secure, or error-free, that defects will be corrected, or that the Service is free of viruses or other harmful components.</p>

            <h2>7. Limitation of Liability</h2>
            <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL DICE DRIVEN DESIGN LLC, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.</p>
            <p>OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THESE TERMS OR THE SERVICE SHALL NOT EXCEED ONE HUNDRED DOLLARS ($100).</p>

            <h2>8. Indemnification</h2>
            <p>You agree to indemnify, defend, and hold harmless Dice Driven Design LLC and its officers, directors, employees, agents, and affiliates from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with your access to or use of the Service or your violation of these Terms.</p>

            <h2>9. Termination</h2>
            <h3>9.1 By You</h3>
            <p>You may request deletion of your account by contacting us at privacy@dicedriven.com.</p>
            <h3>9.2 By Us</h3>
            <p>We may suspend or terminate your access to the Service at any time, with or without cause, and with or without notice.</p>

            <h2>10. Governing Law</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the State of Washington, United States, without regard to its conflict of law provisions. You agree to submit to the personal and exclusive jurisdiction of the courts located in King County, Washington.</p>

            <h2>11. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. If we make material changes, we will notify you by posting a notice on the Service prior to the effective date. Your continued use of the Service after the effective date constitutes your acceptance of the modified Terms.</p>

            <h2>12. Contact Information</h2>
            <p>If you have any questions about these Terms, please contact us at:</p>
            <p><strong>Dice Driven Design LLC</strong><br/>Email: legal@dicedriven.com</p>
        `;
    }
}

customElements.define('terms-of-service', TermsOfService);
